module.exports = __webpack_public_path__ + "images/test-16f14856b869031f1c4d5cad0321d1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/test.jpg
// module id = ./client/assets/images/test.jpg
// module chunks = 0 1 2 4